/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {Snackbar, Typography} from '@mui/material'
import {FormattedMessage} from 'react-intl'
import PrimaryButton from 'src/components/elements/Buttons/PrimaryButton/PrimaryButton'
import SnackbarAlertCustom from 'src/components/elements/SnackbarAlertCustom/SnackbarAlertCustom'
import TableCustom, {PaginationType, TableColumn} from 'src/components/elements/TableCustom/TableCustom'
import LayoutContainer from 'src/components/layouts/LayoutContainer/LayoutContainer'
import Filters, {FilterItem} from 'src/components/templates/Filters/Filters'
import MaterialRequestDialog from 'src/components/templates/MaterialRequestDialog/MaterialRequestDialog'
import {PATHS, STATUS} from 'src/constants/constants'
import apiClient from 'src/services/apiClient'
import {useAppSelector} from 'src/hooks'

const DEFAULT_MATERIAL_COLUMNS: TableColumn[] = [
  {
    id: 'materialName',
    label: 'NOME'
  },
  {
    id: 'requestedQuantity',
    label: 'QUANTITÀ RICHIESTA',
    noSort: true
  },
  {
    id: 'requestDate',
    label: 'DATA DALLA RICHIESTA',
    type: 'date',
    format: 'DD/MM/YYYY'
  }
]

const filterConfig: FilterItem[] = [
  {
    id: 'name',
    label: 'Nome',
    type: 'string'
  },
  {
    id: 'requestDate',
    label: 'Data richiesta',
    type: 'rangePicker'
  }
]

const MaterialRequests = () => {
  const materialColumnOptions = useAppSelector(
    state => state.pspConfigReducer.data.materialRequestsConfigurations?.columnOptions
  )
  const columns: TableColumn[] = materialColumnOptions?.length > 0 ? materialColumnOptions : DEFAULT_MATERIAL_COLUMNS
  const [data, setData] = useState<Record<string, any>[]>([])
  const [filters, setFilters] = useState<Record<string, any>[]>([])
  const [status, setStatus] = useState<any>(undefined)
  const [statusPost, setStatusPost] = useState<any>(undefined)
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)
  const [pagination, setPagination] = useState<PaginationType>({
    page: 0,
    rowsPerPage: 10,
    order: '-requestDate'
  })

  const fetchData = async () => {
    const dateFilter = filters.find((f) => f.property === 'requestDate' && f.type === 'rangePicker')
    const result = await apiClient.getMaterialRequests(
      {
        name: filters.find((f) => f.property === 'name')?.value,
        dateFrom: dateFilter?.value?.[0],
        dateTo: dateFilter?.value?.[1],
        size: pagination.rowsPerPage,
        page: pagination.page,
        sort: pagination.order || undefined
      },
      setStatus
    ) ?? []
    setData(result)
  }

  useEffect(() => {
    fetchData()
  }, [filters, pagination])

  const onSubmit = (values: any) => {
    setFilters(values)
    setPagination((prev) => ({...prev, page: 0}))
  }

  const onRequestSuccess = async () => {
    setIsDialogOpen(false)
    await fetchData()
  }

  return (
    <LayoutContainer
      breadcrumbs={[{label: 'Richiesta materiali', href: PATHS.MATERIAL_REQUESTS}]}
      buttons={[
        <PrimaryButton key='new-request' onClick={() => setIsDialogOpen(true)}>
          <Typography style={{fontSize: 12, fontWeight: 600}}>
            <FormattedMessage defaultMessage='Richiedi materiale' id='requestMaterial' />
          </Typography>
        </PrimaryButton>,
        <Filters config={filterConfig} key='filters' onSubmit={onSubmit} />
      ]}
    >
      <div style={{marginTop: '16px'}}>
        <TableCustom
          columns={columns}
          onPaginationChange={setPagination}
          pagination={pagination}
          rows={data}
          totalElements={data.length}
        />
      </div>
      {isDialogOpen && (
        <MaterialRequestDialog
          onClose={() => setIsDialogOpen(false)}
          onSuccess={onRequestSuccess}
        />
      )}
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        onClose={() => setStatus(undefined)}
        open={status === STATUS.REJECTED}
      >
        <div>
          <SnackbarAlertCustom onClose={() => setStatus(undefined)} severity='error' sx={{width: '100%'}}>
            <Typography variant='h5'>
              {'Errore nel caricare le richieste materiali.'}
            </Typography>
          </SnackbarAlertCustom>
        </div>
      </Snackbar>
      <Snackbar
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}
        onClose={() => setStatusPost(undefined)}
        open={statusPost === STATUS.FULFILLED}
      >
        <div>
          <SnackbarAlertCustom onClose={() => setStatusPost(undefined)} severity='success' sx={{width: '100%'}}>
            <Typography variant='h5'>
              {'Richiesta inviata con successo.'}
            </Typography>
          </SnackbarAlertCustom>
        </div>
      </Snackbar>
    </LayoutContainer>
  )
}

export default MaterialRequests
